import { Outlet } from 'react-router-dom'
import { AuthProvider } from '../auth/auth'
import isLoggedIn from '../utils/is-logged-in'
import DomainChecker from './DomainChecker'

export default function PrivateRoute () {
  if (!isLoggedIn()) {
    return <DomainChecker />
  }

  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  )
}
